<template>
  <div class="app-container" id="account">
    <el-form :model="deviceFormData">
      <el-col :span="24" style="padding-bottom: 10px; margin: 10px 10px">
        <el-form-item>
          <div class="block">
            <span class="demonstration" style="padding-right: 20px">日期</span>
            <el-date-picker
              :clearable="false"
              v-model="deviceFormData.time"
              type="daterange"
              placeholder="选择日期"
              range-separator="至"
              :start-placeholder="deviceFormData.time[0]"
              :end-placeholder="deviceFormData.time[1]"
              :picker-options="pickerOptions"
              @change="timeChang"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </el-form-item>

        <el-form-item label="账号" style="padding-left: 20px">
          <el-input
            v-model="param.account_number"
            placeholder="请输入要查询的代理商账号"
            style="width: 200px"
          ></el-input>
        </el-form-item>

        <el-form-item label="名称" style="padding-left: 20px">
          <el-input
            v-model="param.agent_name"
            placeholder="请输入要查询的代理名称"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item class="searck_agent_btn">
          <el-button
            type="goon"
            icon="el-icon-search"
            @click="search()"
          ></el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button
            type="goon"
            @click="exportExcel()"
            style="margin-left: 20px"
            >导出excel</el-button
          >
        </el-form-item> -->
        <!-- 开始时间  结束时间 -->
      </el-col>
    </el-form>

    <template>
      <el-col :span="24">
        <div class="dls_list app-containerTest">
          <div class="table_title">扫码分成</div>
          <el-table
            :data="tableData"
            style="width: 100%"
            :sort-orders="['ascending', 'descending']"
            :default-sort="{ prop: 'code_sum_mount', order: 'descending' }"
            @sort-change="sortChange"
          >
            <el-table-column
              label="代理id"
              prop="id"
              align="center"
            ></el-table-column>
            <el-table-column
              label="代理账号"
              prop="account_number"
              align="center"
            ></el-table-column>
            <el-table-column
              label="代理名称"
              prop="agent_name"
              align="center"
            ></el-table-column>
            <el-table-column
              label="充值金额"
              prop="code_sum_mount"
              align="center"
              sortable
            ></el-table-column>
            <el-table-column
              label="分成金额"
              prop="fc_sum_mount"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <!--分页条-->
        <el-pagination
          style="padding-bottom: 0px"
          :total="total"
          background
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
        ></el-pagination>
      </el-col>
    </template>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import * as sysApi from "../../common/sys";
import XLSX from "xlsx";
export default {
  data() {
    return {
      tableData: [],
      deviceFormData: {
        time: [],
      },
      //不能选择当前日期之后的时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      total: null,
      param: {
        page: 1,
        page_size: 10,
        agent_name: "",
        start_date: "", //日期
        end_date: "",
        sort: 0, // 高到低   //   2低到高
        account_number: "",
      },
    };
  },
  created() {
    this.$nextTick(function () {
      this.getTimeFn();
      this.init();
    });
  },
  methods: {
    //导出excl
    exportExcel() {
      let par = {
        end_date: this.param.end_date,
        start_date: this.param.start_date,
        agent_name: this.param.agent_name,
        account_number: this.param.account_number,
      };
      sysApi
        .new_agent_list_order_excel(par)
        .then((res) => {
          console.log(res);
          let arrNew = [];
          arrNew.push([
            "代理id",
            "代理账号",
            "代理名称",
            "充值金额",
            "分成金额",
          ]);
          res.list.forEach((element) => {
            let arrNew2 = [];
            arrNew2.push(element.id);
            arrNew2.push(element.account_number);
            arrNew2.push(element.agent_name);
            arrNew2.push(element.code_sum_mount);
            arrNew2.push(element.fc_sum_mount);
            arrNew.push(arrNew2);
          });
          const filename = "orders_fc.xlsx";
          const ws_name = "Sheet1";
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.aoa_to_sheet(arrNew);
          XLSX.utils.book_append_sheet(wb, ws, ws_name); // 将数据添加到工作薄
          XLSX.writeFile(wb, filename); // 导出Exce
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },
    // init    列表
    init(sort) {
      sysApi
        .new_agent_list_order(this.param)
        .then((data) => {
          console.log(data);
          let exp = data.list;
          if (exp === null || exp.length == 0) {
            this.tableData = [];
          } else {
            this.tableData = data.list;
            this.total = data.total_count;
          }
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },
    sortChange(val) {
      if (val.column.order == "ascending") {
        this.param.sort = 1;
      } else {
        this.param.sort = 0;
      }
      this.init();
    },
    search() {
      this.init();
    },
    timeChang(val) {
      this.param.start_date = val[0];
      this.param.end_date = val[1];
      this.init();
    },
    handleCurrentChange(val) {
      this.param.page = val;
      this.init();
    },

    getTimeFn() {
      const that = this;
      const end = new Date();
      //   const start = new Date();
      //   start.setTime(start.getTime() - 3600 * 1000 * 24);
      that.deviceFormData.time[0] = that.formatDate(end);
      that.deviceFormData.time[1] = that.formatDate(end);
    },
    formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();

      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },
  },
};
</script>
<style scope>
.app-containerTest {
  /* height: 520px; */
}
.el-form-item__label{
  float: none !important;
}
.dls_list table td {
  padding: 8px !important;
}

.content-wrapper .content {
  /* padding: 1.25rem 1.25rem 0 1.25rem; */
}

.tab_span {
  height: 37px;
  line-height: 37px;
  font-size: 14px;
}

.tab_span span {
  display: block;
  float: left;
  width: 200px;
  text-align: center;
  cursor: pointer;
  background: #fff;
}

.tab_span span.active {
  background: #409eff;
  color: #fff;
}

.el-table td,
.el-table th {
  padding: 10px 0 !important;
}

.ul_div {
  overflow: hidden;
  width: 100% !important;
  /* position:fixed;
        bottom:20px; */
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
  border-right: 1px solid #333;
  margin-bottom: 15px !important;
  height: 50px;
  /* background: #fff !important; */
}

.ul_div li {
  float: left;
  margin-right: 50px;
  line-height: 50px;
  list-style: none;
  color: #333;
}

.ul_div li.li_li {
  width: 5px;
  background: #409eff;
  height: 50px;
  margin-right: 10px;
}

#account .el-form-item {
  margin-bottom: 22px;
}

#account .el-button {
  /* margin-left: 10px; */
}

#account .recharge_time {
  width: 250px;
}
.input_width {
  width: 260px;
}
#account .el-form-item {
  display: inline-block;
}

#account .el-form-item__content {
  display: inline-block;
}

.agent_add .el-form-item__content {
  margin-left: 0px !important;
}

.agent_add .el-form-item {
  margin-bottom: 20px !important;
  display: block !important;
}

.agent_add_a .el-form-item {
  margin-bottom: 20px !important;
  display: block !important;
}

.agent_add_a .el-form-item__content {
  margin-left: 0px !important;
}

.sao_con {
  width: 500px;
  height: 300px;
  background: #fff;
  position: fixed;
  top: 20%;
  left: 50%;
  margin-left: -250px;
  z-index: 10000;
}

.sao_title {
  display: flex;
}

.searck_agent_btn {
  margin-left: 10px;
}

.sao_title_div {
  text-align: center;
  display: block;
  flex: 10;
  margin-top: 20px;
  font-size: 16px;
}

.el-dialog__headerbtn {
  display: block;
  flex: 2;
}

.sao_contain {
  display: flex;
  width: 90%;
  margin: 20px auto;
}

.saomiao_img {
  flex: 3;
}

.saomiao_right {
  flex: 9;
  padding-left: 10px;
}

.saomiao_right div {
  height: 35px;
  line-height: 35px;
}

.sao_Mask {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
}

.submit_btn {
  width: 120px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  margin: 50px auto 0;
  background-color: #409eff;
  border-color: #409eff;
}

.agent_add .el-form-item__content,
.agent_add_a .el-form-item__content {
  width: 60%;
}

.el-input--suffix .el-input__inner {
  padding-right: 15px !important;
}
#account .el-upload__tip {
  display: inline-block;
  margin-left: 20px;
}

.content-wrapper .content {
  /* padding: 1.25rem 1.25rem 0 1.25rem; */
}
</style>



